import React from 'react';

const QuickViewHeader = ({ children }) => {
  return <div className="quick-header">{children}</div>;
};

export default QuickViewHeader;
